import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  operationKeyValueAll: [],
  operationKeyValue: {},
  selectedCategory: {},
  currentPage: 1,
  totalPages: 1,
  rowsPerPage: 10,
  sortBy: "keyName",
  sortOrder: "asc",
};

const operationKeyValueSlice = createSlice({
  name: "operationKeyValue",
  initialState,
  reducers: {
    setOperationKeyValueAll: (state, action) => {
      state.operationKeyValueAll = action.payload;
    },
    setOperationKeyValue: (state, action) => {
      state.operationKeyValue = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setTotalPages: (state, action) => {
      state.totalPages = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
    setSelectedCategory: (state, action) => {
      state.selectedCategory = action.payload;
    },
  },
});

export const {
  setOperationKeyValueAll,
  setOperationKeyValue,
  setCurrentPage,
  setTotalPages,
  setRowsPerPage,
  setSelectedCategory,
} = operationKeyValueSlice.actions;

export default operationKeyValueSlice.reducer;
